window.batteryReference = {
  "SR416SW": {
  battery: "SR416SW",
  equivalents: ["337"],
  voltage: "1.55 V",
  size: "4.8 × 1.65 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Ultra-thin dress / slim ladies' movements",
    es: "Movimientos ultrafinos para relojes de vestir y relojes de mujer"
  }
},

  "SR512SW": {
  battery: "SR512SW",
  equivalents: ["335"],
  voltage: "1.55 V",
  size: "5.8 × 1.25 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Very thin movements",
    es: "Movimientos muy delgados"
  }
},

  "SR516SW": {
  battery: "SR516SW",
  equivalents: ["317"],
  voltage: "1.55 V",
  size: "5.8 × 1.6 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Small ladies' analog watches",
    es: "Pequeños relojes analógicos para mujer"
  }
},

  "SR521SW": {
  battery: "SR521SW",
  equivalents: ["379"],
  voltage: "1.55 V",
  size: "5.8 × 2.1 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Compact analog movements",
    es: "Movimientos analógicos compactos"
  }
},

  "SR527SW": {
  battery: "SR527SW",
  equivalents: ["319"],
  voltage: "1.55 V",
  size: "5.8 × 2.7 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Small analog watches",
    es: "Pequeños relojes analógicos"
  }
},

  "SR616SW": {
  battery: "SR616SW",
  equivalents: ["321"],
  voltage: "1.55 V",
  size: "6.8 × 1.65 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Thin ladies' watches",
    es: "Relojes finos para mujer"
  }
},

  "SR621SW": {
  battery: "SR621SW",
  equivalents: ["364", "AG1"],
  voltage: "1.55 V",
  size: "6.8 × 2.1 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Common ladies' & mid-size analog",
    es: "Relojes analógicos comunes para mujer y de tamaño mediano"
  }
},

  "SR626SW": {
  battery: "SR626SW",
  equivalents: ["377", "AG4"],
  voltage: "1.55 V",
  size: "6.8 × 2.6 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "One of the most common watch cells",
    es: "Una de las pilas para reloj más comunes"
  }
},

  "SR716SW": {
  battery: "SR716SW",
  equivalents: ["315"],
  voltage: "1.55 V",
  size: "7.9 × 1.65 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Thin analog movements",
    es: "Movimientos analógicos delgados"
  }
},

  "SR721SW": {
  battery: "SR721SW",
  equivalents: ["362", "AG11"],
  voltage: "1.55 V",
  size: "7.9 × 2.1 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Common mid-size analog",
    es: "Relojes analógicos medianos de uso común"
  }
},

  "SR726SW": {
  battery: "SR726SW",
  equivalents: ["397", "AG2"],
  voltage: "1.55 V",
  size: "7.9 × 2.6 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Common men's & unisex analog",
    es: "Relojes analógicos comunes para hombre y unisex"
  }
},

  "SR920SW": {
  battery: "SR920SW",
  equivalents: ["371", "AG6"],
  voltage: "1.55 V",
  size: "9.5 × 2.07 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Common larger analog",
    es: "Relojes analógicos grandes de uso común"
  }
},

  "SR927SW": {
  battery: "SR927SW",
  equivalents: ["399", "AG7"],
  voltage: "1.55 V",
  size: "9.5 × 2.7 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Larger analog & some chronographs",
    es: "Relojes analógicos de mayor tamaño y algunos cronógrafos"
  }
},

  "SR936SW": {
  battery: "SR936SW",
  equivalents: ["394", "AG9"],
  voltage: "1.55 V",
  size: "9.5 × 3.6 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Larger / higher-capacity analog",
    es: "Relojes analógicos de mayor tamaño y mayor capacidad"
  }
},

  "SR1120SW": {
  battery: "SR1120SW",
  equivalents: ["391", "AG8"],
  voltage: "1.55 V",
  size: "11.6 × 2.05 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Large analog watches",
    es: "Relojes analógicos de gran tamaño"
  }
},

  "SR1130SW": {
  battery: "SR1130SW",
  equivalents: ["389", "AG10"],
  voltage: "1.55 V",
  size: "11.6 × 3.05 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Large analog, some chronographs",
    es: "Relojes analógicos de gran tamaño y algunos cronógrafos"
  }
},

  "SR41SW": {
  battery: "SR41SW",
  equivalents: ["392", "AG3", "LR41", "192"],
  voltage: "1.55 V",
  size: "7.9 × 3.6 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Watches, calculators, small electronics",
    es: "Relojes, calculadoras y pequeños dispositivos electrónicos"
  }
},

  "SR43SW": {
  battery: "SR43SW",
  equivalents: ["386", "AG12", "LR43", "186"],
  voltage: "1.55 V",
  size: "11.6 × 4.2 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Watches, medical & small devices",
    es: "Relojes, dispositivos médicos y pequeños dispositivos"
  }
},

  "SR44SW": {
  battery: "SR44SW",
  equivalents: ["357", "AG13", "LR44", "303", "A76"],
  voltage: "1.55 V",
  size: "11.6 × 5.4 mm",
  chemistry: {
    en: "Silver Oxide",
    es: "Óxido de plata"
  },
  use: {
    en: "Watches, calculators — very common",
    es: "Relojes, calculadoras — muy común"
  }
},

  "CR1216": {
  battery: "CR1216",
  equivalents: [],
  voltage: "3.0 V",
  size: "12.5 × 1.6 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Small digital modules, key fobs",
    es: "Módulos digitales pequeños y llaveros con mando"
  }
},

  "CR1220": {
  battery: "CR1220",
  equivalents: [],
  voltage: "3.0 V",
  size: "12.5 × 2.0 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, small devices",
    es: "Relojes digitales y pequeños dispositivos"
  }
},

  "CR1225": {
  battery: "CR1225",
  equivalents: [],
  voltage: "3.0 V",
  size: "12.5 × 2.5 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, electronics",
    es: "Relojes digitales y dispositivos electrónicos"
  }
},

  "CR1616": {
  battery: "CR1616",
  equivalents: [],
  voltage: "3.0 V",
  size: "16.0 × 1.6 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, car remotes",
    es: "Relojes digitales y mandos a distancia para automóviles"
  }
},

  "CR1620": {
  battery: "CR1620",
  equivalents: [],
  voltage: "3.0 V",
  size: "16.0 × 2.0 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, key fobs",
    es: "Relojes digitales y llaveros con mando"
  }
},

  "CR1632": {
  battery: "CR1632",
  equivalents: [],
  voltage: "3.0 V",
  size: "16.0 × 3.2 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, devices",
    es: "Relojes digitales y dispositivos"
  }
},

  "CR2016": {
  battery: "CR2016",
  equivalents: [],
  voltage: "3.0 V",
  size: "20.0 × 1.6 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, fitness trackers",
    es: "Relojes digitales y pulseras de actividad"
  }
},

  "CR2025": {
  battery: "CR2025",
  equivalents: [],
  voltage: "3.0 V",
  size: "20.0 × 2.5 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Digital watches, fitness trackers",
    es: "Relojes digitales y pulseras de actividad"
  }
},

  "CR2032": {
  battery: "CR2032",
  equivalents: [],
  voltage: "3.0 V",
  size: "20.0 × 3.2 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Large digital/hybrid, fitness devices",
    es: "Relojes digitales o híbridos de gran tamaño y dispositivos de actividad física"
  }
},

  "CR2430": {
  battery: "CR2430",
  equivalents: [],
  voltage: "3.0 V",
  size: "24.5 × 3.0 mm",
  chemistry: {
    en: "Lithium",
    es: "Litio"
  },
  use: {
    en: "Larger devices, some smart modules",
    es: "Dispositivos de mayor tamaño y algunos módulos inteligentes"
  }
}
};